var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 19,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m10 0 2.821 6.117 6.69.793-4.946 4.573 1.313 6.607L10 14.8l-5.878 3.29 1.313-6.607L.489 6.91l6.69-.793L10 0Z",
  fill: "#FAC712"
})));
export default SvgStarFilled;